import React from 'react'
import errorImg from "../../asserts/403error.svg"
import Backdrop from "../../asserts/CRMbg.png"
import "../../App.css"

const AccessDenied = () => {
  return (
    <div
    className={`h-screen w-screen px-[2.5vw]`}
    style={{
            backgroundImage: `url(${Backdrop})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
    >
    <img src={errorImg} alt='403 error' className='w-[20vw] mx-auto pt-[5vw]'/>
    <p className='flex justify-center text-[1.5vw] mt-[2vw]'>⚠️ Oops! You Don't Have Access</p>
    <p className='flex justify-center mt-[1vw]'>It looks like you don't have the required permissions to view this page.</p>
    <p className='flex justify-center mt-[1vw]'>If you think you should have access, please reach out to your administrator or support team.</p>
    </div>
  )
}

export default AccessDenied

export const AccessDeniedBox = () => {
  return (
    <div
    className={`w-full h-[78.5vh] rounded-[1vw] bg-[#fff] mt-[0.01vw] border-[#1f4b7f] border-t-[0.1vw] border-l-[0.1vw] border-r-[0.2vw] border-b-[0.2vw] p-[1vw]`}
    >
    <img src={errorImg} alt='403 error' className='w-[20vw] mx-auto pt-[5vw]'/>
    <p className='flex justify-center text-[1.5vw] mt-[2vw]'>⚠️ Oops! You Don't Have Access</p>
    <p className='flex justify-center mt-[1vw]'>It looks like you don't have the required permissions to view this page.</p>
    <p className='flex justify-center mt-[1vw]'>If you think you should have access, please reach out to your administrator or support team.</p>
    </div>
  )
}